import React from 'react';
import ReactApexChart from 'react-apexcharts';

const PennyDropBarChart = ({ grandTotals }) => {
  // Extract grand total values
  const totalSuccess = grandTotals["Grand Total Success (S)"];
  const totalFailed = grandTotals["Grand Total Failed (J)"];
  const totalBlank = grandTotals["Grand Total Blank"];
  const totalRegistered = grandTotals['Grand Total Registered Cases'];

  // Data for the chart
  const categories = ['Total Success', 'Total Failed', 'Total Registered', 'Total Blank'];
  const series = [
    {
      name: 'Count',
      data: [totalSuccess, totalFailed, totalRegistered, totalBlank]
    }
  ];

  // Calculate the total counts
  const totalCounts = [
    { name: 'Total Success', total: totalSuccess },
    { name: 'Total Failed', total: totalFailed },
    { name: 'Total Registered', total: totalRegistered },
    { name: 'Total Blank', total: totalBlank },
  ];

  // Chart options
  const options = {
    chart: {
      type: 'bar',
      height: 500,
      stacked: false,
      toolbar: {
        show: false // Hides the default toolbar
      },
    },
    plotOptions: {
      bar: {
        horizontal: false, // Ensure bars are vertical
        columnWidth: '50%', // Adjust the width of the bars
        dataLabels: {
          position: 'top' // Position data labels on top of bars
        },
      },
    },
    dataLabels: {
      enabled: true, // Enable data labels
      formatter: function (val) {
        return val; // Show the actual value as a label
      },
      offsetY: -20, // Adjust the Y offset so the label is above the bar
      style: {
        fontSize: '14px',
        colors: ['#304758'] // Custom label color
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    title: {
      text: 'Grand Total Summary'
    },
    xaxis: {
      categories: categories, // Categories for the X-axis
      labels: {
        formatter: function (val) {
          return val;
        }
      }
    },
    yaxis: {
      title: {
        text: 'Count' // Label for y-axis
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val; // Tooltip to show actual values
        }
      },
      shared: true, // Show tooltip for all series data points
      intersect: false // Allow tooltip to show on hover over the bar
    },
    fill: {
      opacity: 1
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40
    },
    colors: ['#5470c6'] // Custom color for the series
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ flex: 1 }}>
        <ReactApexChart options={options} series={series} type="bar" height={500} width={"100%"}/>
      </div>
      <div
        style={{
          padding: "10px",
          backgroundColor: "inherit",
          borderTop: "1px solid #ddd",
        }}
        className='px-4 py-2'
      >
        <div className="d-flex flex-column">
          <div>
            <div style={{ color: "#36454F", fontSize: "16px", fontWeight: "600" }} className='mb-2'>
              Total Counts:
            </div>
            <div className='d-flex gap-2 flex-wrap'>

            {totalCounts.map((item, index) => (
              <div
              key={index}
              style={{
                marginBottom: "5px",
                fontSize: "14px"
              }}
              className="d-flex align-items-center justify-content-end mr-2" 
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    backgroundColor: options.colors[0], // Use the same color as the bars
                    display: "inline-block",
                    marginRight: "5px",
                    borderRadius: "50%",
                  }}
                  ></div>
                <span
                  className="d-block me-1"
                  style={{ fontWeight: "500", color: "#808080" }}
                  >
                  {item.name}:
                </span>
                <span style={{ color: "#000000", fontWeight: "700" }}>
                  {item.total}
                </span>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PennyDropBarChart;
